import { Box, Grid, Hidden, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React from 'react';

export interface VisualizationBoxItem {
  icon: string;
  title: string;
  text: string;
}

export interface VisualizationBoxProps {
  title: string;
  items: VisualizationBoxItem[];
}

const isOdd = (n: number) => n % 2 === 1;

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 400
  },
  image: {
    width: '150px'
  }
}));

export const VisualizationBox: React.FC<VisualizationBoxProps> = ({ title, items }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container direction="column">
      {title && (
        <Grid item>
          <Typography variant="h2" className={classes.title}>
            {title}
          </Typography>
        </Grid>
      )}

      {items.map((item, idx) => (
        <Box
          key={idx}
          display="flex"
          alignContent="center"
          alignItems={mobile ? '' : 'flex-start'}
          flexDirection={mobile ? 'column' : isOdd(idx) ? 'row-reverse' : 'row'}
          marginX={mobile ? -2.5 : 0}
          padding={mobile ? 2.5 : 2.25}
          paddingLeft={mobile ? 2.5 : isOdd(idx) ? 2.25 : 0}
          paddingRight={mobile ? 2.5 : isOdd(idx) ? 0 : 2.25}
          paddingTop={mobile ? 1 : 0}
          paddingBottom={mobile ? 2.5 : 0}
          bgcolor={isOdd(idx) ? CORPORATE_COLORS.RX_LIGHT : ''}
        >
          {/* Image */}
          <Box
            display="flex"
            justifyContent={mobile ? 'center' : isOdd(idx) ? 'flex-end' : 'flex-start'}
            margin={mobile ? '0 0 10px 0' : isOdd(idx) ? '0 0 0 44px' : '0 44px 0 0'}
          >
            <img src={item.icon} alt={`Step ${idx} icon`} className={classes.image} />
          </Box>
          {/* Text */}
          <Box alignItems="flex-start" flexGrow={1} paddingY={mobile ? 0 : 2.5}>
            {/* Title desktop */}
            <Hidden smDown>
              <Box marginBottom={1.25}>
                <Typography variant="subtitle1">
                  <span>
                    {idx + 1} - {item.title}{' '}
                  </span>
                </Typography>
              </Box>
            </Hidden>
            {/* Title mobile */}
            <Hidden mdUp>
              <Box marginBottom={1.5}>
                <Typography variant="subtitle2">
                  <span>
                    {idx + 1} - {item.title}{' '}
                  </span>
                </Typography>
              </Box>
            </Hidden>
            {/* Body text */}
            <Typography variant="body1">{item.text}</Typography>
          </Box>
        </Box>
      ))}
    </Grid>
  );
};
